<script>
  import Datepicker from "vuejs-datepicker"
  import { ptBR } from "vuejs-datepicker/dist/locale"
  import { format } from "date-fns"
  import ScheduleForm from "@/domains/lines/views/schedules/partials/ScheduleForm.vue"
  import LineInfoForm from "./LineInfoForm.vue"
  import Modal from "@/core/components/NewModal.vue"
  import RegularLineService from "@/domains/lines/services/RegularLineService"
  import SectionPointSelect from "./SectionPointSelect.vue"

  export default {
    components: {
      ScheduleForm,
      LineInfoForm,
      SectionPointSelect,
      Modal,
      Datepicker,
    },
    props: {
      lineModel: {
        type: Object,
        required: true,
      },
      lineFormSuccess: {
        type: Number,
        default: 0,
      },
      sections: {
        type: Array,
        required: true,
      },
      isEdit: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        locale: ptBR,
        currentItinerary: "",
        itineraries: [],
        originalItineraries: [],
        periodBegin: new Date(new Date().getFullYear(), 0, 1),
        periodBeginFormatted: "01/01",
        periodEnd: new Date(new Date().getFullYear(), 11, 31),
        periodEndFormatted: "31/12",
        origin_point: "",
        destiny_point: "",

        formErrors: {
          periodBegin: false,
          periodEnd: false,
        },

        schedules: [],
        originalSchedules: [],
        intersections: [
          {
            scheduleIndex: null,
            intersectionType: "",
          },
        ],

        copyScheduleFrom: null,
        previewPeriod: [],
        regularLineService: new RegularLineService(),
        displayPreviusButton: false,
        displayNextButton: true,

        simulateSubmitLineForm: 0,

        changedLineInfo: false,
        changedScheduleInfo: false,
        changedItineraryInfo: false,

        lineScheduleFormSuccess: 0,

        currentStep: "LineInfo",
        step: "current",
        sectionPoint: {
          nmlocalidade: "",
          delocalidade: "",
          numunicipio: null,
          gelat: "",
          gelng: "",
          flsituacao: 1,
        },
        sectionPoints: [],
      }
    },
    watch: {
      lineModel: {
        handler() {
          this.schedules = this.groupSchedulesBySeasonality(
            this.lineModel.line_schedules
          )
          this.originalSchedules = JSON.parse(JSON.stringify(this.schedules))
          this.itineraries = this.lineModel.deitinerario
            ? this.lineModel.deitinerario.split(",").map((i) => i.trim())
            : []
          this.originalItineraries = JSON.parse(
            JSON.stringify(this.itineraries)
          )
          this.sectionPoints = this.lineModel.sections || []
        },
        deep: true,
      },
      lineFormSuccess: {
        handler() {
          this.changedLineInfo = false
          this.changeStep()
        },
      },
      lineScheduleFormSuccess: {
        handler() {
          this.changedScheduleInfo = false
          this.changeStep()
        },
      },
    },
    methods: {
      /**
       * Envia o formulário da linha
       */
      submitLineForm() {
        this.$emit("submitLineForm")
      },

      /**
       * Envia o formulário de horários
       */
      submitScheduleForm() {
        try {
          this.regularLineService
            .insertOrUpdateSchedules(this.lineModel.idlinha, this.schedules)
            .then(() => {
              this.lineScheduleFormSuccess += 1
              this.$toast.success({
                title: "Sucesso",
                message: "Quadro de horários cadastrado com sucesso",
              })
              this.originalSchedules = JSON.parse(
                JSON.stringify(this.schedules)
              )
            })
            .catch((error) => {
              this.$toast.error({
                title: "Erro",
                message: error.message,
              })
            })
        } catch (error) {
          this.$toast.error({
            title: "Erro",
            message: "Erro ao cadastrar quadro de horários",
          })
        }
      },
      submitSectionPointsForm() {
        try {
          if (!this.lineModel.idlinha) {
            this.$toast.error({
              title: "Erro",
              message:
                "A linha ainda não foi criada. Salve os dados iniciais antes de cadastrar os pontos de seção.",
            })
            return
          }

          if (this.sectionPoints.length === 0) {
            this.$toast.error({
              title: "Erro",
              message: "Nenhum secionamento criado.",
            })
            return
          }

          // Define origem e destino com base nos dados de seção
          const originId = this.sectionPoints?.[0]?.nupontoorigem || null
          const destinyId =
            this.sectionPoints?.[this.sectionPoints.length - 1]
              ?.nupontodestino || null

          this.lineModel.nupontoorigem = originId
          this.lineModel.nupontodestino = destinyId

          // Atualiza os dados da linha
          this.regularLineService
            .updateRegularLine(this.lineModel.idlinha, this.lineModel)
            .catch((error) => {
              this.$toast.error({
                title: "Erro",
                message:
                  "Erro ao salvar origem/destino: " +
                  (error.response?.data?.message || error.message),
              })
            })

          this.lineModel.sections = this.sectionPoints

          const hasSections =
            this.lineModel.sections?.length > 0 &&
            this.lineModel.sections[0].idsecao
          const action = hasSections ? "put" : "post"

          this.regularLineService
            .insertOrUpdateSectionPoints(this.lineModel.sections, action)
            .then(() => {
              this.$toast.success({
                title: "Sucesso",
                message: "Pontos de seção cadastrados com sucesso",
              })
            })
            .catch((error) => {
              this.$toast.error({
                title: "Erro",
                message:
                  error.response?.data?.message ||
                  error.message ||
                  "Erro desconhecido",
              })
            })
        } catch (error) {
          this.$toast.error({
            title: "Erro",
            message: "Erro ao cadastrar pontos de seção",
          })
        }
      },

      /**
       * Envia o formulário do itinerário
       */
      submitItineraryForm() {
        try {
          this.addItinerary()
          this.regularLineService
            .insertOrUpdateItineraries(this.lineModel.idlinha, this.itineraries)
            .then(() => {
              this.$toast.success({
                title: "Sucesso",
                message: "Itinerário cadastrado com sucesso",
              })
              this.originalItineraries = JSON.parse(
                JSON.stringify(this.itineraries)
              )
              this.changedItineraryInfo = false
              if (!this.isEdit) {
                this.$router.push({ name: "lines.regular.index" })
              }
            })
            .catch((error) => {
              this.$toast.error({
                title: "Erro",
                message: error.message,
              })
            })
        } catch (error) {
          this.$toast.error({
            title: "Erro",
            message: "Erro ao cadastrar itinerário",
          })
        }
      },

      /**
       * Define que houve alterações no formulário do itinerário
       */
      changeItineraryForm() {
        this.changedItineraryInfo = true
      },

      /**
       * Agrupa os quadros de horários por sazonalidade
       * @param {Array} horarios Lista de quadros de horários
       * @returns {Array} Lista de quadros de horários agrupados por sazonalidade
       */
      groupSchedulesBySeasonality(horarios) {
        const schedules = []
        const seasonality = []

        horarios.forEach((horario) => {
          const seasonalityIndex = seasonality.findIndex(
            (s) => s.idsazonalidade === horario.nusazonalidade
          )

          if (seasonalityIndex === -1) {
            seasonality.push({
              idsazonalidade: horario.nusazonalidade,
              desazonalidade: horario.seasonality.desazonalidade,
            })
            schedules.push({
              seasonality: horario.seasonality.desazonalidade,
              schedules: [horario],
              dtinicio: horario.seasonality.dtinicio,
              dtfim: horario.seasonality.dtfim,
              idsazonalidade: horario.nusazonalidade,
            })
          } else {
            schedules[seasonalityIndex].schedules.push(horario)
          }
        })

        return schedules
      },

      /**
       * Adiciona um itinerário à lista de itinerários
       */
      addItinerary() {
        const trimmedItinerary = this.currentItinerary.trim()
        if (trimmedItinerary) {
          this.itineraries.push(trimmedItinerary) // Adiciona o itinerário à lista
          this.currentItinerary = "" // Limpa o campo de texto
          this.changedItineraryInfo = true
        }
      },

      /**
       * Remove um itinerário da lista de itinerários
       * @param {number} index Índice do itinerário a ser removido
       */
      removeItinerary(index) {
        this.itineraries.splice(index, 1)
        this.changedItineraryInfo = true
      },

      /**
       * Valida o período ao adicionar
       */
      validatePeriod() {
        if (!this.periodBegin) {
          this.$toast.error({
            title: "Erro",
            message: "Informe o início do período",
          })
          this.formErrors.periodBegin = true
        }
        if (!this.periodEnd) {
          this.$toast.error({
            title: "Erro",
            message: "Informe o fim do período",
          })
          this.formErrors.periodEnd = true
        }

        if (!this.periodBegin || !this.periodEnd) {
          return false
        }
        this.periodBeginFormatted = format(this.periodBegin, "dd/MM")
        this.periodEndFormatted = format(this.periodEnd, "dd/MM")

        if (this.schedules.length === 0) {
          this.addPeriod()
        } else {
          let negative =
            this.toDayOfYear(this.periodBeginFormatted) >
            this.toDayOfYear(this.periodEndFormatted)

          let begin = this.toDayOfYear(this.periodBeginFormatted, negative)
          let end = this.toDayOfYear(this.periodEndFormatted)
          this.intersections = this.verifyIntersections(begin, end)

          this.intersections = this.intersections.filter((i) => i !== null)

          if (this.intersections.length > 0) {
            this.makeIntersectionsPreview()
            this.$refs.intersectionModal.show()
          } else {
            this.$refs.periodModal.show()
          }
        }
      },

      /**
       * Adiciona um período à lista de períodos
       */
      addPeriod() {
        this.$refs.periodModal.hide()

        let negative =
          this.toDayOfYear(this.periodBeginFormatted) >
          this.toDayOfYear(this.periodEndFormatted)

        let begin = this.toDayOfYear(this.periodBeginFormatted, negative)
        let end = this.toDayOfYear(this.periodEndFormatted)
        this.intersections = []

        this.intersections = this.verifyIntersections(begin, end)

        this.intersections = this.intersections.filter((i) => i !== null)

        if (this.intersections.length > 0) {
          this.manageIntersections(begin, end)
        }

        let newSchedules = []
        if (this.copyScheduleFrom !== null) {
          newSchedules = this.schedules[this.copyScheduleFrom].schedules.map(
            (schedule) => {
              return {
                ...schedule,
                idhorario: null,
              }
            }
          )
        }

        this.schedules.push({
          seasonality: `${this.periodBeginFormatted} - ${this.periodEndFormatted}`,
          dtinicio: begin,
          dtfim: end,
          schedules: newSchedules,
          idsazonalidade: null,
        })

        this.copyScheduleFrom = null

        this.periodBegin = ""
        this.periodEnd = ""
        this.periodBeginFormatted = ""
        this.periodEndFormatted = ""

        this.formErrors.periodBegin = false
        this.formErrors.periodEnd = false

        this.orderSchedules()
      },

      /**
       * Converte uma data no formato dd/mm para o dia do ano
       * @param {string} dayMonth Data no formato dd/mm
       * @param {boolean} negative Flag para retornar o dia do ano negativo
       * @returns {number} Dia do ano
       */
      toDayOfYear(dayMonth, negative = false) {
        let day = parseInt(dayMonth.split("/")[0])
        let month = parseInt(dayMonth.split("/")[1])
        let date = new Date(negative ? 1969 : 1970, month - 1, day)
        let baseDate = new Date(1970, 0, 0)
        let diff = date - baseDate
        let oneDay = 1000 * 60 * 60 * 24
        let dayInt = diff / oneDay
        let dayFloor = Math.floor(dayInt)
        return dayFloor
      },

      /**
       * Converte o dia do ano para uma data no formato dd/mm
       * @param {number} dayOfYear Dia do ano
       * @returns {string} Data no formato dd/mm
       */
      toDayMonth(dayOfYear) {
        let date = new Date(1970, 0, dayOfYear)
        return date.toLocaleDateString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
        })
      },

      /**
       * Verifica se o período se sobrepõe com algum período existente
       * @param {number} begin Início do período
       * @param {number} end Fim do período
       * @returns {Array} Lista de índices dos períodos que se sobrepõem
       */
      verifyIntersections(begin, end) {
        let intersections = []
        this.schedules.forEach((schedule, i) => {
          switch (true) {
            case begin === 1 && end === 365:
              intersections.push({
                scheduleIndex: i,
                intersectionType: "contains",
              })
              break
            case schedule.dtinicio < 0 &&
              begin > 0 &&
              begin < schedule.dtfim &&
              end > schedule.dtinicio + 365 &&
              schedule.dtinicio + schedule.dtfim < end - begin:
              intersections.push({
                scheduleIndex: i,
                intersectionType: "negativeContained",
              })
              break
            case schedule.dtinicio < 0 && begin < 0:
              intersections.push(
                this.defineNormalIntersection(
                  schedule,
                  i,
                  begin,
                  end,
                  intersections
                )
              )
              break
            case schedule.dtinicio < 0 && begin >= 0:
              intersections.push(
                this.defineNormalIntersection(
                  schedule,
                  i,
                  begin,
                  end,
                  intersections
                )
              )
              break
            case schedule.dtinicio >= 0 && begin < 0:
              intersections.push(
                this.defineNegativeIntersection(
                  schedule,
                  i,
                  begin,
                  end,
                  intersections
                )
              )
              break
            case schedule.dtinicio >= 0 && begin >= 0:
              intersections.push(
                this.defineNormalIntersection(
                  schedule,
                  i,
                  begin,
                  end,
                  intersections
                )
              )
              break
            default:
              break
          }
        })
        return intersections
      },

      /**
       * Define a interseção normal
       * @param {Object} schedule Período
       * @param {number} i Índice do período
       * @param {number} begin Início do período
       * @param {number} end Fim do período
       * @returns {Object} Objeto de interseção
       */
      defineNormalIntersection(schedule, i, begin, end) {
        let beginAux = begin
        let endAux = end
        if (
          schedule.dtinicio < 0 &&
          begin > 0 &&
          end - 365 > schedule.dtinicio &&
          end - 365 < schedule.dtfim
        ) {
          beginAux = begin - 365
          endAux = end - 365
        }
        // contido, ou seja, divide o período que o contém em dois períodos
        if (beginAux > schedule.dtinicio && endAux < schedule.dtfim) {
          return {
            scheduleIndex: i,
            intersectionType: "contained",
          }
        }

        // contém, ou seja, remove o período contido
        if (beginAux <= schedule.dtinicio && endAux >= schedule.dtfim) {
          return {
            scheduleIndex: i,
            intersectionType: "contains",
          }
        }

        // início contido, ou seja, ajusta o início do período que o contém para ser igual ao fim do período contido
        if (
          beginAux <= schedule.dtinicio &&
          endAux <= schedule.dtfim &&
          endAux >= schedule.dtinicio
        ) {
          return {
            scheduleIndex: i,
            intersectionType: "beginContained",
          }
        }

        // fim contido, ou seja, ajusta o fim do período que o contém para ser igual ao início do período contido
        if (
          beginAux >= schedule.dtinicio &&
          endAux >= schedule.dtfim &&
          begin <= schedule.dtfim
        ) {
          return {
            scheduleIndex: i,
            intersectionType: "endContained",
          }
        }
        return null
      },

      /**
       * Define a interseção negativa
       * @param {Object} schedule Período
       * @param {number} i Índice do período
       * @param {number} begin Início do período
       * @param {number} end Fim do período
       * @returns {Object} Objeto de interseção
       */
      defineNegativeIntersection(schedule, i, begin, end) {
        // intersecciona paralelamente no início do período, então encurta o fim do período que é sobreposto
        if (
          end < schedule.dtinicio &&
          end < schedule.dtfim &&
          begin + 365 < schedule.dtfim
        ) {
          return {
            scheduleIndex: i,
            intersectionType: "beginParallel",
          }
        }

        // intersecciona paralelamente no fim do período, então encurta o início do período que é sobreposto
        if (
          end > schedule.dtinicio &&
          end < schedule.dtfim &&
          begin + 365 > schedule.dtfim
        ) {
          return {
            scheduleIndex: i,
            intersectionType: "endParallel",
          }
        }

        // intersecciona paralelamente, então divide o período que o contém em dois períodos
        if (
          end > schedule.dtinicio &&
          end < schedule.dtfim &&
          begin + 365 <= schedule.dtfim
        ) {
          return {
            scheduleIndex: i,
            intersectionType: "parallel",
          }
        }

        if (begin < schedule.dtinicio && end > schedule.dtfim) {
          return {
            scheduleIndex: i,
            intersectionType: "contains",
          }
        }
        return null
      },

      /**
       * Gerencia os períodos que se sobrepõem
       * @param {number} begin Início do período
       * @param {number} end Fim do período
       * @returns {void}
       */
      manageIntersections(begin, end) {
        this.intersections.forEach((intersection) => {
          let scheduleBegin =
            this.schedules[intersection.scheduleIndex].seasonality.split(
              " - "
            )[0]
          let scheduleEnd =
            this.schedules[intersection.scheduleIndex].seasonality.split(
              " - "
            )[1]

          switch (intersection.intersectionType) {
            case "contained":
              this.schedules.push({
                seasonality: `${scheduleBegin} - ${this.toDayMonth(begin - 1)}`,
                dtinicio: this.schedules[intersection.scheduleIndex].dtinicio,
                dtfim: begin - 1,
                schedules: this.schedules[intersection.scheduleIndex].schedules,
                idsazonalidade: null,
              })
              this.schedules.push({
                seasonality: `${this.toDayMonth(end + 1)} - ${scheduleEnd}`,
                dtinicio: end + 1,
                dtfim: this.schedules[intersection.scheduleIndex].dtfim,
                schedules: this.schedules[intersection.scheduleIndex].schedules,
                idsazonalidade: null,
              })
              this.schedules[intersection.scheduleIndex] = null
              break
            case "contains":
              this.schedules[intersection.scheduleIndex] = null
              break
            case "beginContained":
              this.schedules[intersection.scheduleIndex].dtinicio = end + 1
              this.schedules[intersection.scheduleIndex].seasonality =
                `${this.toDayMonth(end + 1)} - ${scheduleEnd}`
              break
            case "endContained":
              this.schedules[intersection.scheduleIndex].dtfim = begin - 1
              this.schedules[intersection.scheduleIndex].seasonality =
                `${scheduleBegin} - ${this.toDayMonth(begin - 1)}`
              break
            case "beginParallel":
              this.schedules[intersection.scheduleIndex].dtfim = begin + 365 - 1
              break
            case "endParallel":
              this.schedules[intersection.scheduleIndex].dtinicio = end + 1
              break
            case "parallel":
              this.schedules[intersection.scheduleIndex].dtfim = begin + 365 - 1
              this.schedules[intersection.scheduleIndex].dtinicio = end + 1
              this.schedules[intersection.scheduleIndex].seasonality =
                `${this.toDayMonth(
                  end + 1
                )} - ${this.toDayMonth(begin + 365 - 1)}`
              break
            case "negativeContained":
              this.schedules[intersection.scheduleIndex].dtinicio =
                end + 1 - 365
              this.schedules[intersection.scheduleIndex].dtfim = begin - 1
              this.schedules[intersection.scheduleIndex].seasonality =
                `${this.toDayMonth(end + 1)} - ${this.toDayMonth(begin - 1)}`
              this.schedules[intersection.scheduleIndex].schedules =
                this.schedules[intersection.scheduleIndex].schedules
              break
            default:
              break
          }
        })
        this.schedules = this.schedules.filter((s) => s !== null)
      },

      /**
       * Preview da lista de períodos
       * @return {string} Preview das datas no formato dd/MM
       */
      makeIntersectionsPreview() {
        if (this.schedules.length === 0) {
          this.previewPeriod = [
            {
              seasonality: `${this.toDayMonth(
                begin
              )} - ${this.toDayMonth(end)}`,
              dtinicio: this.toDayOfYear(this.periodBeginFormatted),
              dtfim: this.toDayOfYear(this.periodEndFormatted),
            },
          ]
          return
        }

        this.previewPeriod = this.schedules.map((schedule) => {
          return {
            seasonality: schedule.seasonality,
            dtinicio: schedule.dtinicio,
            dtfim: schedule.dtfim,
          }
        })

        let negative =
          this.toDayOfYear(this.periodBeginFormatted) >
          this.toDayOfYear(this.periodEndFormatted)

        let begin = this.toDayOfYear(this.periodBeginFormatted, negative)
        let end = this.toDayOfYear(this.periodEndFormatted)

        this.intersections.forEach((intersection) => {
          let scheduleBegin =
            this.schedules[intersection.scheduleIndex].seasonality.split(
              " - "
            )[0]
          let scheduleEnd =
            this.schedules[intersection.scheduleIndex].seasonality.split(
              " - "
            )[1]

          switch (intersection.intersectionType) {
            case "contained":
              this.previewPeriod.push({
                seasonality: `${scheduleBegin} - ${this.toDayMonth(begin - 1)}`,
                dtinicio:
                  this.previewPeriod[intersection.scheduleIndex].dtinicio,
                dtfim: begin - 1,
              })
              this.previewPeriod.push({
                seasonality: `${this.toDayMonth(end + 1)} - ${scheduleEnd}`,
                dtinicio: end + 1,
                dtfim: this.previewPeriod[intersection.scheduleIndex].dtfim,
              })
              this.previewPeriod[intersection.scheduleIndex] = null
              break
            case "contains":
              this.previewPeriod[intersection.scheduleIndex] = null
              break
            case "beginContained":
              this.previewPeriod[intersection.scheduleIndex] = {
                seasonality: `${this.toDayMonth(end + 1)} - ${scheduleEnd}`,
                dtinicio: end + 1,
                dtfim: this.previewPeriod[intersection.scheduleIndex].dtfim,
              }
              break
            case "endContained":
              this.previewPeriod[intersection.scheduleIndex] = {
                seasonality: `${scheduleBegin} - ${this.toDayMonth(begin - 1)}`,
                dtinicio:
                  this.previewPeriod[intersection.scheduleIndex].dtinicio,
                dtfim: begin - 1,
              }
              break
            case "beginParallel":
              this.previewPeriod[intersection.scheduleIndex] = {
                seasonality: `${scheduleBegin} - ${this.toDayMonth(
                  begin + 365 - 1
                )}`,
                dtinicio:
                  this.previewPeriod[intersection.scheduleIndex].dtinicio,
                dtfim: begin + 365 - 1,
              }
              break
            case "endParallel":
              this.previewPeriod[intersection.scheduleIndex] = {
                seasonality: `${this.toDayMonth(end + 1)} - ${scheduleEnd}`,
                dtinicio: end + 1,
                dtfim: this.previewPeriod[intersection.scheduleIndex].dtfim,
              }
              break
            case "parallel":
              this.previewPeriod[intersection.scheduleIndex] = {
                seasonality: `${this.toDayMonth(
                  end + 1
                )} - ${this.toDayMonth(begin + 365 - 1)}`,
                dtinicio: end + 1,
                dtfim: begin + 365 - 1,
              }
              break
            case "negativeContained":
              this.previewPeriod[intersection.scheduleIndex] = {
                seasonality: `${this.toDayMonth(
                  end + 1
                )} - ${this.toDayMonth(begin - 1)}`,
                dtinicio: end + 1 - 365,
                dtfim: begin - 1,
              }
              break
            default:
              break
          }
        })
        this.previewPeriod.push({
          seasonality: `${this.toDayMonth(begin)} - ${this.toDayMonth(end)}`,
          dtinicio: begin,
          dtfim: end,
        })

        this.previewPeriod = this.previewPeriod.filter((s) => s !== null)

        return this.orderSchedulePreview(this.previewPeriod)
      },

      /**
       * Ordena os períodos por dia de início, desconsiderando datas negativas
       */
      orderSchedules() {
        this.schedules = this.schedules.sort((a, b) => {
          if (a.dtinicio < 0) {
            return 1
          }
          if (b.dtinicio < 0) {
            return -1
          }
          return a.dtinicio - b.dtinicio
        })
      },

      /**
       * Ordena o preview dos períodos por início
       * @param {Array} preview Lista de períodos
       */
      orderSchedulePreview(preview) {
        return preview.sort((a, b) => {
          if (a.dtinicio < 0) {
            return 1
          }
          if (b.dtinicio < 0) {
            return -1
          }
          return a.dtinicio - b.dtinicio
        })
      },

      /**
       * Remove um período da lista de períodos
       */
      removeSchedule(index) {
        this.changeScheduleForm()
        this.schedules.splice(index, 1)
      },

      changeStep() {
        switch (this.step) {
          case "next":
            this.nextStep()
            break
          case "previous":
            this.previousStep()
            break
          case "current":
            break
          default:
            this.onDirectSelectStep(this.step)
            break
        }
      },

      /**
       * Alterna entre as listas de quadro de horários, pontos de seção e itinerário
       * @param {string} type Tipo de lista a ser exibida
       */
      toggleList(type) {
        this.currentStep = type
        this.displayNextButton = true
        this.displayPreviusButton = true
        if (type.includes("Itinerary")) {
          this.displayNextButton = false
        }
        if (type.includes("LineInfo")) {
          this.displayPreviusButton = false
        }

        // define refs como um array de keys
        Object.keys(this.$refs).forEach((key) => {
          if (
            key.includes("periodModal") ||
            key.includes("periodButton") ||
            key.includes("periodSection") ||
            key.includes("intersectionModal") ||
            key.includes("confirmChangeModal")
          ) {
            return
          }

          // verifica se a key contém o tipo selecionado
          if (key.includes(type)) {
            // se list, remove a classe hidden
            if (key.includes("section")) {
              this.$refs[key].classList.remove("hidden")
            }
          } else {
            // se list, adiciona a classe hidden
            if (key.includes("section")) {
              this.$refs[key].classList.add("hidden")
            }
          }
        })
      },

      /**
       * Alterna entre exibir e ocultar uma seção dos horários
       * @param {string} index Índice da seção a ser exibida/ocultada
       */
      collapse(index) {
        const section = this.$refs[`periodSection-${index}`][0]
        const button = this.$refs[`periodButton-${index}`][0]

        if (section.classList.contains("hidden-section")) {
          section.classList.remove("hidden-section")
          section.classList.add("display-section")
          button.classList.add("rotate-180")
        } else {
          section.classList.remove("display-section")
          section.classList.add("hidden-section")
          button.classList.remove("rotate-180")
          button.classList.add("rotate")
        }
      },

      /**
       * Ao selecionar um passo diretamente
       */
      onDirectSelectStep(nextStep) {
        this.step = nextStep
        if (
          this.changedLineInfo ||
          this.changedScheduleInfo ||
          this.changedItineraryInfo
        ) {
          this.$refs.confirmChangeModal.show()
          return
        }
        this.toggleList(nextStep)
      },

      /**
       * Retorna a seção atual do formulário
       */
      getActualFormSection() {
        let actualSection = ""
        Object.keys(this.$refs).every((key) => {
          if (
            !key.includes("periodModal") &&
            !key.includes("periodButton") &&
            !key.includes("periodSection") &&
            !key.includes("intersectionModal") &&
            !key.includes("confirmChangeModal") &&
            key.includes("section")
          ) {
            if (!this.$refs[key].classList.contains("hidden")) {
              actualSection = key
              return false
            }
          }
          return true
        })
        return actualSection
      },

      /**
       * Avança para a próxima seção do formulário
       */
      nextStep() {
        this.step = "next"
        if (
          this.changedLineInfo ||
          this.changedScheduleInfo ||
          this.changedItineraryInfo
        ) {
          this.$refs.confirmChangeModal.show()
          return
        }
        switch (this.getActualFormSection()) {
          case "sectionLineInfo":
            this.toggleList("RegularSchedules")
            break
          case "sectionRegularSchedules":
            this.toggleList("SectionPoints")
            break
          case "sectionSectionPoints":
            this.toggleList("Itinerary")
            break
          default:
            break
        }
      },

      /**
       * Retorna para a seção anterior do formulário
       */
      previousStep() {
        this.step = "previous"
        if (
          this.changedLineInfo ||
          this.changedScheduleInfo ||
          this.changedItineraryInfo
        ) {
          this.$refs.confirmChangeModal.show()
          return
        }
        switch (this.getActualFormSection()) {
          case "sectionRegularSchedules":
            this.toggleList("LineInfo")
            break
          case "sectionSectionPoints":
            this.toggleList("RegularSchedules")
            break
          case "sectionItinerary":
            this.toggleList("SectionPoints")
            break
          default:
            break
        }
      },

      /**
       * Define que houve alterações no formulário da linha
       */
      changeLineForm() {
        this.changedLineInfo = true
      },

      /**
       * Define que houve alterações no formulário de horários
       */
      changeScheduleForm() {
        this.changedScheduleInfo = true
      },

      /**
       * Salva o formulário atual
       */
      saveCurrentForm(nextStep) {
        this.step = nextStep
        switch (this.getActualFormSection()) {
          case "sectionLineInfo":
            this.submitLineForm()
            break
          case "sectionRegularSchedules":
            this.submitScheduleForm()
            break
          case "sectionSectionPoints":
            this.submitSectionPointsForm()
            break
          case "sectionItinerary":
            this.submitItineraryForm()
            break
          default:
            break
        }
        this.$refs.confirmChangeModal.hide()
      },

      /**
       * Descarta as alterações do formulário e retorna as informações originais
       */
      discardChanges(nextStep) {
        this.step = nextStep
        let keys = []
        switch (this.getActualFormSection()) {
          case "sectionLineInfo":
            keys = [
              "nulinharamal",
              "nuextensao",
              "nutransportadora",
              "transportadoraForm",
              "tpviagem",
              "tpoperacao",
              "tpservcompl",
              "fltoalete",
              "patamarizada",
              "flsituacao",
              "vlcoeficientemultiplicacao",
              "nuservicoveiculo",
              "tpoutorga",
              "dtiniciocontrato",
              "dtfimcontrato",
              "dtiniciolinha",
            ]
            this.$emit("discardChanges", keys)
            break
          case "sectionRegularSchedules":
            this.$nextTick(() => {
              this.schedules = JSON.parse(
                JSON.stringify(this.originalSchedules)
              )
            })
            break
          case "sectionItinerary":
            this.$nextTick(() => {
              this.itineraries = JSON.parse(
                JSON.stringify(this.originalItineraries)
              )
            })
            break
          default:
            break
        }
        this.changedLineInfo = false
        this.changedScheduleInfo = false
        this.changedItineraryInfo = false
        this.$refs.confirmChangeModal.hide()
        this.changeStep()
      },

      closeConfirmChangeModal() {
        this.$refs.confirmChangeModal.hide()
      },
      updateSectionPoints(newSectionPoints) {
        this.sectionPoints = newSectionPoints
      },
    },
  }
</script>
<style scoped>
  .chips {
    display: flex;
    flex-wrap: wrap;
  }

  .chip {
    background-color: #f1f1f1;
    border-radius: 20px;
    padding: 5px 10px;
    margin: 5px;
    display: flex;
    align-items: center;
  }

  .close {
    margin-left: 10px;
    cursor: pointer;
    color: red;
  }

  button:focus {
    outline: 0 !important;
  }

  .first-button {
    clip-path: polygon(
      95% 0%,
      100% 50%,
      95% 100%,
      0% 100%,
      0% 50%,
      0% 0%
    ) !important;
  }

  .last-button {
    clip-path: polygon(
      100% 0%,
      100% 50%,
      100% 100%,
      0% 100%,
      5% 50%,
      0% 0%
    ) !important;
  }

  .selected-button {
    color: white;
    background-image: linear-gradient(to right, #38c172, #029e4d);
    clip-path: polygon(95% 0%, 100% 50%, 95% 100%, 0% 100%, 5% 50%, 0% 0%);
  }

  .non-selected-button {
    opacity: 0.5;
    background-image: linear-gradient(to right, #b4e5c7, #38c172);
    clip-path: polygon(95% 0%, 100% 50%, 95% 100%, 0% 100%, 5% 50%, 0% 0%);
  }

  .disabled-button {
    background-image: linear-gradient(to right, #a1a1a1, #c2c2c2);
  }

  .regular-line-schedule-form-section-title {
    color: white;
    font-size: larger;
    background-image: linear-gradient(to right, #38c172, #029e4d);
    padding: 10px 20px;
    text-transform: uppercase;
    border-radius: 3px;
  }

  .regular-line-schedule-form-section-title-disabled {
    color: white;
    font-size: larger;
    background-image: linear-gradient(to right, #b4e5c7, #38c172);
    padding: 10px 20px;
    text-transform: uppercase;
    border-radius: 3px;
  }

  .rotate:focus,
  .rotate-180:focus {
    outline: 0;
  }

  .rotate {
    transition: transform 0.2s cubic-bezier(0.62, 0.28, 0.23, 0.99);
    transform: rotate(0deg);
  }

  .rotate-180 {
    transition: transform 0.2s cubic-bezier(0.62, 0.28, 0.23, 0.99);
    transform: rotate(180deg);
  }

  .hidden-section {
    max-height: 0;
    transition: max-height 0.6s cubic-bezier(0.33, -0.22, 0.56, 1.09);
    overflow: hidden;
  }

  .display-section {
    max-height: 5000px;
    transition: max-height 0.7s cubic-bezier(0.69, 0, 0.94, 0.81);
    overflow: hidden;
  }
</style>
<template>
  <div>
    <portal-target name="modals" :multiple="true"/>
    <Modal ref="confirmChangeModal">
      <div class="flex flex-col justify-center items-center p-6">
        <h1 class="text-center mb-4">
          O formulário contém alterações que não foram salvas.
          <br>
          Deseja salvar?
        </h1>
        <div class="grid grid-cols-3 gap-4">
          <button
            class="form-gray p-2"
            type="button"
            @click="closeConfirmChangeModal"
          >
            Cancelar
          </button>
          <button
            class="form-red p-2"
            type="button"
            @click="discardChanges(step)"
          >
            Descartar
          </button>
          <button
            class="form-new-green p-2"
            type="button"
            @click="saveCurrentForm(step)"
          >
            Salvar
          </button>
        </div>
      </div>
    </Modal>

    <Modal ref="periodModal">
      <div class="flex flex-col justify-center items-center p-6">
        <h1 class="text-center mb-4">
          Você está prestes a adicionar um novo período.
          <br>
          Deseja copiar os horários de outro período?
        </h1>
        <select v-model="copyScheduleFrom" class="form-input w-3/4 mb-7">
          <option value="" disabled selected>Selecione um período</option>
          <option
            v-for="(schedule, index) in schedules"
            :key="index"
            :value="index"
          >
            {{ schedule.seasonality }}
          </option>
          <option value="null">Não copiar</option>
        </select>
        <div class="flex">
          <button class="form-new-green p-2" type="button" @click="addPeriod()">
            Adicionar Novo Período
          </button>
        </div>
      </div>
    </Modal>

    <Modal ref="intersectionModal">
      <div class="flex flex-col justify-center items-center p-6">
        <h1 class="text-center mb-7">
          O período selecionado se sobrepõe com outro(s) período(s).
          <br>A adição do período resultará em: <br>
          <div v-for="(period, index) in previewPeriod" :key="index">
            <span>{{ period.seasonality }}</span>
          </div>
        </h1>
        <div class="flex">
          <button
            class="form-new-green p-2"
            type="button"
            @click="
                            () => {
                                $refs.intersectionModal.hide();
                                $refs.periodModal.show();
                            }
                        "
          >
            Confirmar
          </button>
          <button
            class="form-red p-2 ml-4"
            type="button"
            @click="$refs.intersectionModal.hide()"
          >
            Cancelar
          </button>
        </div>
      </div>
    </Modal>
    <div
      class="col-span-6 grid grid-cols-1 md:grid-cols-4 gap-2 text-lg mb-1 w-full"
    >
      <button
        ref="buttonLineInfo"
        type="menu"
        class="col-span-1 first-button text-center content-center h-16 uppercase shadow-md"
        :class="[
                    currentStep === 'LineInfo'
                        ? 'selected-button'
                        : 'non-selected-button',
                    currentStep !== 'LineInfo' ? 'hidden md:block' : ''
                ]"
        @click="
                    e => {
                        e.preventDefault();
                        onDirectSelectStep('LineInfo');
                    }
                "
        @keyup.enter.stop
      >
        Informações da Linha
      </button>
      <button
        ref="buttonRegularSchedules"
        type="menu"
        class="col-span-1 text-center content-center h-16 uppercase shadow-md"
        :class="[
                    currentStep === 'RegularSchedules'
                        ? 'selected-button'
                        : 'non-selected-button',
                    currentStep !== 'RegularSchedules' ? 'hidden md:block' : ''
                ]"
        :disabled="!lineModel.idlinha"
        @click="
                    e => {
                        e.preventDefault();
                        onDirectSelectStep('RegularSchedules');
                    }
                "
        @keyup.enter.stop
      >
        Quadro de Horários
      </button>
      <button
        ref="buttonSectionPoints"
        type="menu"
        class="col-span-1 text-center content-center h-16 uppercase shadow-md"
        :class="[
                    currentStep === 'SectionPoints'
                        ? 'selected-button'
                        : 'non-selected-button',
                    currentStep !== 'SectionPoints' ? 'hidden md:block' : ''
                ]"
        :disabled="!lineModel.idlinha"
        @click="
                    e => {
                        e.preventDefault();
                        onDirectSelectStep('SectionPoints');
                    }
                "
      >
        Pontos de Seção
      </button>
      <button
        ref="buttonItinerary"
        type="menu"
        class="col-span-1 last-button text-center content-center h-16 uppercase shadow-md"
        :class="[
                    currentStep === 'Itinerary'
                        ? 'selected-button'
                        : 'non-selected-button',
                    currentStep !== 'Itinerary' ? 'hidden md:block' : ''
                ]"
        :disabled="!lineModel.idlinha"
        @click="
                    e => {
                        e.preventDefault();
                        onDirectSelectStep('Itinerary');
                    }
                "
        @keyup.enter.stop
      >
        Itinerário
      </button>
    </div>
    <div ref="sectionLineInfo" class="shadow-md p-4">
      <LineInfoForm
        :line-model="lineModel"
        :simulate-submit-line-form="simulateSubmitLineForm"
        @submit="submitLineForm"
        @changeLineForm="changeLineForm"
      />
    </div>
    <div ref="sectionRegularSchedules" class="hidden col-span-6 shadow-md p-4">
      <div class="grid grid-cols-1 md:grid-cols-5 gap-4 items-end mb-4">
        <label class="form-label text-lg text-green-base md:col-span-1">
          Período
        </label>
        <div class="md:col-span-1">
          <label class="form-label" for="periodBegin">Início:</label>
          <Datepicker
            id="period-begin"
            v-model="periodBegin"
            model-type="string"
            format="dd/MM"
            maximum-view="month"
            :open-date="new Date(new Date().getFullYear(), 0, 1)"
            :language="locale"
            :full-month-name="true"
            :input-class="{
                            'form-input': true,
                            'mb-0': true,
                            'bg-red-100 border-red-400':
                                formErrors.periodBegin && !periodBegin,
                        }"
          />
        </div>
        <div class="md:col-span-1">
          <label class="form-label" for="periodEnd">Fim:</label>
          <Datepicker
            id="period-end"
            v-model="periodEnd"
            format="dd/MM"
            maximum-view="month"
            :open-date="new Date(new Date().getFullYear(), 11, 31)"
            :language="locale"
            :full-month-name="true"
            :input-class="{
                            'form-input': true,
                            'mb-0': true,
                            'bg-red-100 border-red-400':
                                formErrors.periodEnd && !periodEnd,
                        }"
          />
        </div>
        <button
          class="form-new-green h-10 md:col-span-2"
          type="button"
          @click="validatePeriod"
        >
          Adicionar Período
        </button>
      </div>
      <div v-for="(period, index) in schedules" :key="index" class="mb-4">
        <div
          class="regular-line-schedule-form-section-title flex justify-between items-center display-section"
        >
          <h1>{{ period.seasonality }}</h1>
          <div>
            <button
              :ref="`periodButton-${index}`"
              class="rotate-180"
              type="button"
              @click="collapse(index)"
            >
              <img class="h-9" src="@/core/assets/images/icon_caret_.svg">
            </button>
          </div>
        </div>
        <div :ref="`periodSection-${index}`">
          <ScheduleForm
            :key="index"
            :schedule-model="period"
            @changeScheduleForm="changeScheduleForm"
          />
          <button
            class="form-red p-2"
            type="button"
            @click="removeSchedule(index)"
          >
            Remover Período
          </button>
        </div>
      </div>
      <!-- <div class="grid grid-cols-6">
                <button
                    type="button"
                    class="col-start-6 form-submit py-2"
                    @click="submitScheduleForm()"
                >
                    Salvar Quadro de Horários
                </button>
            </div> -->
    </div>
    <div ref="sectionSectionPoints" class="hidden col-span-6 shadow-md p-4">
      <SectionPointSelect
        :line-model="lineModel"
        :sectionPointsForm="sectionPoints"
        :patamar="lineModel.patamar"
        :isEdit="isEdit"
        @update-section-points="sectionPoints = $event"
      />
    </div>
    <div ref="sectionItinerary" class="hidden col-span-6 shadow-md p-4">
      <div class="mb-3">
        <label class="form-label" for="descricao-itinerario">
          Descrição do Itinerário:
        </label>
        <template>
          <div class="itinerary-input">
            <input
              v-model="currentItinerary"
              type="text"
              class="form-input"
              @keyup.enter="
                                (e) => {
                                    e.preventDefault();
                                    addItinerary();
                                    changeItineraryForm();
                                }
                            "
            >
            <br>
            <div class="chips">
              <span
                v-for="(itinerary, index) in itineraries"
                :key="index"
                class="chip"
              >
                {{ itinerary }}
                <span
                  class="close"
                  @click="() => {
                                        removeItinerary(index);
                                        changeItineraryForm();
                                    }"
                  >x</span
                >
              </span>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div
      class="bg-white shadow-md p-4 mt-4 flex flex-col sm:flex-row sm:justify-between gap-4"
    >
      <div class="w-full sm:w-1/4 md:w-1/6">
        <button
          v-if="displayPreviusButton"
          type="Button"
          class="form-submit py-2"
          @click="previousStep"
        >
          Voltar
        </button>
      </div>
      <div class="w-full sm:w-auto flex flex-col sm:flex-row-reverse gap-4">
        <button
          v-if="displayNextButton"
          type="button"
          class="form-submit py-2"
          :class="{
                        'disabled-button': !lineModel.idlinha,
                        hidden: !lineModel.idlinha
                    }"
          :disabled="!lineModel.idlinha"
          @click="nextStep"
        >
          Avançar
        </button>
        <button
          v-else
          type="button"
          class="form-submit py-2"
          :class="{
                        'disabled-button': !lineModel.idlinha
                    }"
          :disabled="!lineModel.idlinha"
          @click="addItinerary"
        >
          Adicionar
        </button>
        <button
          type="button"
          class="form-submit bg-green-profile py-2"
          @click="saveCurrentForm('current')"
        >
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>
